$(document).ready(function() {
    function bhFilterStickyPosition() {
        var headerHeight = $('.site-header').outerHeight();
        // Also update top position of sticky sidebar
        var stickySidebar = $('.collection-filter');
        if (stickySidebar) {
            stickySidebar.css('--collection-filter-top', headerHeight+'px');
        }
    }
    bhFilterStickyPosition();
    $(window).on('scroll', function() {
        bhFilterStickyPosition();
    });
    $(window).on('resize', function() {
        bhFilterStickyPosition();
    });
    $('.collection-filter__btn').click(function(e) {
        e.stopPropagation();
        $(this).parents('.collection-filter').toggleClass('active');
    });
    $('.collection-filter').click(function (e) {
        e.stopPropagation();
    });
    $(document).click(function () {
        $('.collection-filter__btn.is-active').click();
    });
});